import { ExclamationIcon } from "@heroicons/react/outline";
import { CheckIcon } from "@heroicons/react/solid";
import { useEffect, useMemo, useRef, useState } from "react";
import ReactDatePicker from "react-datepicker";
import { useTranslation } from "react-i18next";
import { PatternFormat } from "react-number-format";
import { useNavigate } from "react-router-dom";
import { classNames } from "../../Utils";
import { Alert } from "../../Components/Alert";
import { Button } from "../../Components/Button";
import {
  clearRegisterNPWP,
  clearUpdateNPWPDraft,
  requestCreateNPWPDraft,
  requestGetUser,
  requestRegisterNPWP,
  requestUpdateNPWPDraft,
  useAuthDispatch,
  useAuthState,
  useNPWPDispatch,
  useNPWPState,
} from "../../Context";
import dayjs from "dayjs";
import ReactSelect from "react-select";
import AsyncSelect from "react-select/async";
import { generateClient } from "aws-amplify/api";
import algoliasearch from "algoliasearch/lite";
import { ModalConfirm } from "../../Components/ModalConfirm";
import { useRemoteConfig } from "../../Context/firebase/context";

const client = generateClient();

const steps = [
  {
    id: 1,
    name: "Identity",
  },
  {
    id: 2,
    name: "Income",
  },
  {
    id: 3,
    name: "Address",
  },
];

const INCOME_SOURCE = [
  {
    label: "Employee",
    value: "1",
  },
  {
    label: "Business",
    value: "2",
  },
  {
    label: "Freelance",
    value: "3",
  },
  {
    label: "Other Jobs",
    value: "4",
  },
];

const INCOME_LEVELS = [
  {
    label: "Less than Rp.4,500,000",
    value: "1",
  },
  {
    label: "Rp.4,500,000 to Rp.9,999,999",
    value: "2",
  },
  {
    label: "Rp.10,000,000 to Rp.14,999,999",
    value: "3",
  },
  {
    label: "Rp.15,000,000 to Rp.19,999,999",
    value: "4",
  },
  {
    label: "More than or equal Rp.20,000,000",
    value: "5",
  },
];

const BOOKKEEPING_TYPES = [
  {
    label: "Bookkeeping",
    value: true,
  },
  {
    label: "Recordkeeping",
    value: false,
  },
];

const EMPLOYEE_TYPES = [
  {
    label: "Private Employee",
    value: "96301",
  },
  {
    label: "Employee of SOE/Regional-Owned Enterprises",
    value: "96302",
  },
  {
    label: "Civil Servant",
    value: "96303",
  },
  {
    label: "Military and Police Member",
    value: "96303",
  },
  { label: "Pensioner", value: "96305" },
];

const MONTHS = [
  { label: "January", value: "01" },
  { label: "February", value: "02" },
  { label: "March", value: "03" },
  { label: "April", value: "04" },
  { label: "May", value: "05" },
  { label: "June", value: "06" },
  { label: "July", value: "07" },
  { label: "August", value: "08" },
  { label: "September", value: "09" },
  { label: "October", value: "10" },
  { label: "November", value: "11" },
  { label: "December", value: "12" },
];

export const NPWPCreate = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useNPWPDispatch();
  const authDispatch = useAuthDispatch();
  const { user, getUserLoading } = useAuthState();
  const {
    statusNPWPDraft,
    loading,
    errorNPWPRegister,
    errorNPWPDraft,
    registeredNpwpID,
    silentUpdate,
  } = useNPWPState();
  const { npwp_registration } = useRemoteConfig();

  const [showDraftSuccessModal, setshowDraftSuccessModal] = useState(false);
  const [showSubmitSuccessModal, setshowSubmitSuccessModal] = useState(false);
  const [showDraftErrorModal, setshowDraftErrorModal] = useState(false);
  const [showSubmitErrorModal, setshowSubmitErrorModal] = useState(false);
  const [modalDraftDescription, setmodalDraftDescription] = useState("");
  const [modalSubmitDescription, setmodalSubmitDescription] = useState("");

  const [currentStep, setCurrentStep] = useState(1);
  const [formValid, setformValid] = useState({});
  const [translatedEmployeeTypes, settranslatedEmployeeTypes] = useState([]);
  const [translatedIncomeLevels, settranslatedIncomeLevels] = useState([]);
  const [subdistrictLoading, setsubdistrictLoading] = useState(false);
  const [businessCodeLoading, setbusinessCodeLoading] = useState(false);

  const [getSearchIdSubdistrict, setgetSearchIdSubdistrict] = useState("");
  const [getSearchSubdistrict, setgetSearchSubdistrict] = useState("");
  const [getSearchBusinessSubdistrict, setgetSearchBusinessSubdistrict] =
    useState("");
  const [getListBusiness, setgetListBusiness] = useState("");
  const [getListFreelance, setgetListFreelance] = useState("");
  const [getListOther, setgetListOther] = useState("");

  /* identity state */
  const [name, setname] = useState("");
  const [cellPhone, setcellPhone] = useState("");
  const [nik, setnik] = useState("");
  const [email, setemail] = useState("");
  const [birthPlace, setbirthPlace] = useState("");
  const [birthDate, setbirthDate] = useState(new Date());
  const [kk, setkk] = useState("");

  /* income state */
  const [incomeTaxpayer, setincomeTaxpayer] = useState("");
  const [totalDependant, settotalDependant] = useState("");

  const [employeeSelected, setemployeeSelected] = useState(false);
  const [employeeCode, setemployeeCode] = useState("");
  const [employeeDescription, setemployeeDescription] = useState("");

  const [businessSelected, setbusinessSelected] = useState(false);
  const [businessCode, setbusinessCode] = useState("");
  const [businessDescription, setbusinessDescription] = useState("");
  const [businessHasEmployee, setbusinessHasEmployee] = useState(false);
  const [businessName, setbusinessName] = useState("");
  const [useBookeping, setuseBookeping] = useState(true);
  const [startBookkeeping, setstartBookkeeping] = useState("");

  const [freelanceSelected, setfreelanceSelected] = useState(false);
  const [freelanceCode, setfreelanceCode] = useState("");
  const [freelanceDescription, setfreelanceDescription] = useState("");
  const [freelanceName, setfreelanceName] = useState("");
  const [freelanceHasEmployee, setfreelanceHasEmployee] = useState(false);
  const [freelanceUseBookeping, setfreelanceUseBookeping] = useState(true);
  const [freelanceBookeepingStart, setfreelanceBookeepingStart] = useState("");

  const [otherSelected, setotherSelected] = useState(false);
  const [otherCode, setotherCode] = useState("");
  const [otherDescription, setotherDescription] = useState("");

  /* address state */
  const [selectedIdSubdistrict, setselectedIdSubdistrict] = useState("");
  const [idStreet, setidStreet] = useState("");
  const [idStreetNumber, setidStreetNumber] = useState("");
  const [idStreetBlock, setidStreetBlock] = useState("");
  const [idRtNumber, setidRtNumber] = useState("");
  const [idRwNumber, setidRwNumber] = useState("");

  const [sameAddress, setsameAddress] = useState(false);
  const [sameResidentialAddress, setsameResidentialAddress] = useState(false);

  const [selectedSubdistrict, setselectedSubdistrict] = useState("");
  const [street, setstreet] = useState("");
  const [streetNumber, setstreetNumber] = useState("");
  const [streetBlock, setstreetBlock] = useState("");
  const [rtNumber, setrtNumber] = useState("");
  const [rwNumber, setrwNumber] = useState("");

  const [selectedBusinessSubdistrict, setselectedBusinessSubdistrict] =
    useState("");
  const [businessStreet, setbusinessStreet] = useState("");
  const [businessStreetNumber, setbusinessStreetNumber] = useState("");
  const [businessBlock, setbusinessBlock] = useState("");
  const [businessRtNumber, setbusinessRtNumber] = useState("");
  const [businessRwNumber, setbusinessRwNumber] = useState("");

  const clientRef = useRef(
    algoliasearch("6K1WS0YK0O", "341c247d3d694308f40a61b46ad4faa7")
  );
  const indexRef = useRef(
    clientRef.current.initIndex(
      "PajakInd-businesscode-vtrekrba7jhx7otxovphczikfq"
    )
  );

  const convertGetIdSubdistrict = useMemo(
    () => ({
      ...getSearchIdSubdistrict,
      label: getSearchIdSubdistrict.name,
      value: getSearchIdSubdistrict.id,
    }),
    [getSearchIdSubdistrict]
  );

  const convertGetSubdistrict = useMemo(
    () => ({
      ...getSearchSubdistrict,
      label: getSearchSubdistrict.name,
      value: getSearchSubdistrict.id,
    }),
    [getSearchSubdistrict]
  );

  const convertGetBusinessSubdistrict = useMemo(
    () => ({
      ...getSearchBusinessSubdistrict,
      label: getSearchBusinessSubdistrict.name,
      value: getSearchBusinessSubdistrict.id,
    }),
    [getSearchBusinessSubdistrict]
  );

  useEffect(() => {
    const currentMonth = String(new Date().getMonth() + 1).padStart(2, "0");
    setstartBookkeeping(currentMonth);
    setfreelanceBookeepingStart(currentMonth);
  }, []);

  useEffect(() => {
    if (user.sub) {
      requestGetUser(authDispatch, { sub: user.sub });
    }
  }, [authDispatch, user.sub]);

  useEffect(() => {
    if (statusNPWPDraft === "SUCCESS" && !silentUpdate) {
      setshowDraftSuccessModal(true);
    }
  }, [statusNPWPDraft, silentUpdate]);

  useEffect(() => {
    if (errorNPWPDraft) {
      setshowDraftErrorModal(true);
    }
  }, [errorNPWPDraft]);

  useEffect(() => {
    if (registeredNpwpID) {
      setshowSubmitSuccessModal(true);
    }
  }, [registeredNpwpID]);

  useEffect(() => {
    if (errorNPWPRegister) {
      setshowSubmitErrorModal(true);
    }
  }, [errorNPWPRegister]);

  useEffect(() => {
    const getDataSubdistrict = async () => {
      try {
        if (user.npwpDraft.idRegionCode) {
          const res = await client.graphql({
            query: getSubdistrict,
            variables: {
              id: user.npwpDraft?.idRegionCode,
            },
          });
          setgetSearchIdSubdistrict(res.data.getSubdistrict);
        } else {
          setgetSearchIdSubdistrict("");
        }
      } catch {
        setgetSearchIdSubdistrict("");
      }
    };
    getDataSubdistrict();
  }, [user.npwpDraft?.idRegionCode]);

  useEffect(() => {
    const getDataSubdistrict = async () => {
      try {
        if (user.npwpDraft.regionCode) {
          const res = await client.graphql({
            query: getSubdistrict,
            variables: {
              id: user.npwpDraft?.regionCode,
            },
          });
          setgetSearchSubdistrict(res.data.getSubdistrict);
        } else {
          setgetSearchSubdistrict("");
        }
      } catch {
        setgetSearchSubdistrict("");
      }
    };
    getDataSubdistrict();
  }, [user.npwpDraft?.regionCode]);

  useEffect(() => {
    const getDataSubdistrict = async () => {
      try {
        if (user.npwpDraft.businessRegionCode) {
          const res = await client.graphql({
            query: getSubdistrict,
            variables: {
              id: user.npwpDraft?.businessRegionCode,
            },
          });
          setgetSearchBusinessSubdistrict(res.data.getSubdistrict);
        } else {
          setgetSearchBusinessSubdistrict("");
        }
      } catch {
        setgetSearchBusinessSubdistrict("");
      }
    };
    getDataSubdistrict();
  }, [user.npwpDraft?.businessRegionCode]);

  useEffect(() => {
    const getDataListBusiness = async () => {
      try {
        if (user.npwpDraft.businessCode) {
          const res = await client.graphql({
            query: getBusinessCode,
            variables: {
              id: user.npwpDraft?.businessCode,
            },
          });
          setgetListBusiness(res.data.getBusinessCode);
        } else {
          setgetListBusiness("");
        }
      } catch {
        setgetListBusiness("");
      }
    };
    getDataListBusiness();
  }, [user.npwpDraft?.businessCode]);

  useEffect(() => {
    const getDataListFreelance = async () => {
      try {
        if (user.npwpDraft.freelanceCode) {
          const res = await client.graphql({
            query: getBusinessCode,
            variables: {
              id: user.npwpDraft?.freelanceCode,
            },
          });
          setgetListFreelance(res.data.getBusinessCode);
        } else {
          setgetListFreelance("");
        }
      } catch {
        setgetListFreelance("");
      }
    };
    getDataListFreelance();
  }, [user.npwpDraft?.freelanceCode]);

  useEffect(() => {
    const getDataListOther = async () => {
      try {
        if (user.npwpDraft?.otherCode) {
          const res = await client.graphql({
            query: getBusinessCode,
            variables: {
              id: user.npwpDraft?.otherCode,
            },
          });
          setgetListOther(res.data.getBusinessCode);
        } else {
          setgetListOther("");
        }
      } catch {
        setgetListOther("");
      }
    };
    getDataListOther();
  }, [user.npwpDraft?.otherCode]);

  useEffect(() => {
    const errorMessageDraft =
      getErrorMessage(errorNPWPDraft?.errors) ||
      "NPWP draft failed to be saved";
    setmodalDraftDescription(t(errorMessageDraft));
  }, [errorNPWPDraft, t]);

  useEffect(() => {
    const parsedErrorResponse = errorNPWPRegister?.response?.body
      ? JSON.parse(errorNPWPRegister.response.body)
      : null;
    if (parsedErrorResponse.message) {
      setmodalSubmitDescription(parsedErrorResponse.message);
    } else {
      const errorMessageSubmit =
        getErrorMessage(errorNPWPRegister?.errors) || "NPWP Registered failed";
      setmodalSubmitDescription(t(errorMessageSubmit));
    }
  }, [errorNPWPRegister, t]);

  useEffect(() => {
    const currentIncomeLevel = INCOME_LEVELS.map((incomeLevel) => ({
      ...incomeLevel,
      label: t(incomeLevel.label),
    }));
    settranslatedIncomeLevels(currentIncomeLevel);
  }, [t]);

  useEffect(() => {
    const currentEmployeeTypes = EMPLOYEE_TYPES.map((employeeType) => ({
      ...employeeType,
      label: t(employeeType.label),
    }));
    settranslatedEmployeeTypes(currentEmployeeTypes);
  }, [t]);

  useEffect(() => {
    if (user.registeredNpwp?.id) {
      navigate(`/settings/npwp`);
    }
  }, [user, navigate]);

  useEffect(() => {
    /* identity */
    if (user.npwpDraft?.name) {
      setname(user.npwpDraft?.name);
    }
    if (user.npwpDraft?.cellPhone) {
      let currentCellPhone = user.npwpDraft?.cellPhone;
      if (currentCellPhone.startsWith("0")) {
        currentCellPhone = "62" + currentCellPhone.substring(1);
      }
      setcellPhone(currentCellPhone);
    }
    if (user.npwpDraft?.identityId) {
      setnik(user.npwpDraft?.identityId);
    }
    if (user.npwpDraft?.birthPlace) {
      setbirthPlace(user.npwpDraft?.birthPlace);
    }
    if (user.npwpDraft?.birthDate) {
      const startDate = user.npwpDraft?.birthDate;
      const date = new Date(startDate.split("-").reverse().join("-"));
      setbirthDate(date);
    }
    if (user.npwpDraft?.familyId) {
      setkk(user.npwpDraft?.familyId);
    }

    /* income */
    if (user.npwpDraft?.totalDependant) {
      settotalDependant(user.npwpDraft?.totalDependant);
    }
    if (user.npwpDraft?.totalDependant === 0) {
      settotalDependant("0");
    }
    if (user.npwpDraft?.incomeLevel) {
      setincomeTaxpayer(
        translatedIncomeLevels.filter(
          (translatedIncomeLevel) =>
            translatedIncomeLevel.value ===
            user.npwpDraft?.incomeLevel.toString()
        )
      );
    }

    /* income employee */
    if (user.npwpDraft?.employeeCode) {
      setemployeeSelected(true);
      setemployeeCode(
        translatedEmployeeTypes.find(
          (translatedEmployeeType) =>
            translatedEmployeeType.value === user.npwpDraft?.employeeCode
        )
      );
    }
    if (user.npwpDraft?.employeeDescription) {
      setemployeeSelected(true);
      setemployeeDescription(user.npwpDraft?.employeeDescription);
    }

    /* income business */
    if (user.npwpDraft?.businessCode) {
      setbusinessSelected(true);
      setbusinessCode({
        ...getListBusiness,
        label: getListBusiness.description,
        value: getListBusiness.id,
      });
    }
    if (user.npwpDraft?.businessDescription) {
      setbusinessSelected(true);
      setbusinessDescription(user.npwpDraft?.businessDescription);
    }
    if (user.npwpDraft?.businessName) {
      setbusinessSelected(true);
      setbusinessName(user.npwpDraft?.businessName);
    }
    if (user.npwpDraft?.businessHasEmployee) {
      setbusinessSelected(true);
      setbusinessHasEmployee(user.npwpDraft?.businessHasEmployee);
    }
    if (user.npwpDraft?.businessBookeeping === 1) {
      setbusinessSelected(true);
      setuseBookeping(true);
    }
    if (user.npwpDraft?.businessBookeeping === 2) {
      setbusinessSelected(true);
      setuseBookeping(false);
    }
    if (user.npwpDraft?.businessBookeepingStart) {
      setbusinessSelected(true);
      setstartBookkeeping(user.npwpDraft?.businessBookeepingStart);
    }

    /* income freelance */
    if (user.npwpDraft?.freelanceCode) {
      setfreelanceSelected(true);
      setfreelanceCode({
        ...getListFreelance,
        label: getListFreelance.description,
        value: getListFreelance.id,
      });
    }
    if (user.npwpDraft?.freelanceDescription) {
      setfreelanceSelected(true);
      setfreelanceDescription(user.npwpDraft?.freelanceDescription);
    }
    if (user.npwpDraft?.freelanceName) {
      setfreelanceSelected(true);
      setfreelanceName(user.npwpDraft?.freelanceName);
    }
    if (user.npwpDraft?.freelanceBookeeping === 1) {
      setfreelanceSelected(true);
      setfreelanceUseBookeping(true);
    }
    if (user.npwpDraft?.freelanceBookeeping === 2) {
      setfreelanceSelected(true);
      setfreelanceUseBookeping(false);
    }
    if (user.npwpDraft?.freelanceHasEmployee) {
      setfreelanceSelected(true);
      setfreelanceHasEmployee(user.npwpDraft?.freelanceHasEmployee);
    }
    if (user.npwpDraft?.freelanceBookeepingStart) {
      setfreelanceSelected(true);
      setfreelanceBookeepingStart(user.npwpDraft?.freelanceBookeepingStart);
    }

    /* income other */
    if (user.npwpDraft?.otherCode) {
      setotherSelected(true);
      setotherCode({
        ...getListOther,
        label: getListOther.description,
        value: getListOther.id,
      });
    }
    if (user.npwpDraft?.otherDescription) {
      setotherSelected(true);
      setotherDescription(user.npwpDraft?.otherDescription);
    }

    /* address ID */
    if (user.npwpDraft?.idRegionCode) {
      setselectedIdSubdistrict(convertGetIdSubdistrict);
    }
    if (user.npwpDraft?.idStreet) {
      setidStreet(user.npwpDraft?.idStreet);
    }
    if (user.npwpDraft?.idRtNumber) {
      setidRtNumber(user.npwpDraft?.idRtNumber);
    }
    if (user.npwpDraft?.idRwNumber) {
      setidRwNumber(user.npwpDraft?.idRtNumber);
    }
    if (user.npwpDraft?.idBlock) {
      setidStreetBlock(user.npwpDraft?.idBlock);
    }
    if (user.npwpDraft?.idStreetNumber) {
      setidStreetNumber(user.npwpDraft?.idStreetNumber);
    }

    /* address Living */
    if (user.npwpDraft) {
      if (user.npwpDraft?.regionCode === user.npwpDraft?.idRegionCode) {
        setsameAddress(true);
      } else {
        if (user.npwpDraft?.regionCode) {
          setselectedSubdistrict(convertGetSubdistrict);
        }
        if (user.npwpDraft?.street) {
          setstreet(user.npwpDraft?.street);
        }
        if (user.npwpDraft?.idRtNumber) {
          setrtNumber(user.npwpDraft?.rtNumber);
        }
        if (user.npwpDraft?.rwNumber) {
          setrwNumber(user.npwpDraft?.rwNumber);
        }
        if (user.npwpDraft?.block) {
          setstreetBlock(user.npwpDraft?.block);
        }
        if (user.npwpDraft?.streetNumber) {
          setstreetNumber(user.npwpDraft?.streetNumber);
        }
      }
      if (
        user.npwpDraft?.regionCode === "" &&
        user.npwpDraft?.idRegionCode === ""
      ) {
        setsameAddress(false);
      }
    }

    /* address Business */
    if (user.npwpDraft) {
      if (user.npwpDraft?.businessRegionCode === user.npwpDraft?.regionCode) {
        setsameResidentialAddress(true);
      } else {
        if (user.npwpDraft?.businessRegionCode) {
          setbusinessSelected(true);
          setselectedBusinessSubdistrict(convertGetBusinessSubdistrict);
        }
        if (user.npwpDraft?.businessStreet) {
          setbusinessStreet(user.npwpDraft?.businessStreet);
        }
        if (user.npwpDraft?.businessRtNumber) {
          setbusinessRtNumber(user.npwpDraft?.businessRtNumber);
        }
        if (user.npwpDraft?.businessRwNumber) {
          setbusinessRwNumber(user.npwpDraft?.businessRwNumber);
        }
        if (user.npwpDraft?.businessBlock) {
          setbusinessBlock(user.npwpDraft?.businessBlock);
        }
        if (user.npwpDraft?.businessStreetNumber) {
          setbusinessStreetNumber(user.npwpDraft?.businessStreetNumber);
        }
      }
      if (
        user.npwpDraft?.regionCode === "" &&
        user.npwpDraft?.businessRegionCode === ""
      ) {
        setsameResidentialAddress(false);
      }
    }
  }, [
    user.npwpDraft,
    convertGetIdSubdistrict,
    convertGetSubdistrict,
    convertGetBusinessSubdistrict,
    getListBusiness,
    getListFreelance,
    getListOther,
    translatedIncomeLevels,
    translatedEmployeeTypes,
  ]);

  useEffect(() => {
    if (sameAddress) {
      setselectedSubdistrict(selectedIdSubdistrict);
      setstreet(idStreet);
      setstreetBlock(idStreetBlock);
      setstreetNumber(idStreetNumber);
      setrtNumber(idRtNumber);
      setrwNumber(idRwNumber);
    }
    if (sameResidentialAddress) {
      setselectedBusinessSubdistrict(selectedSubdistrict);
      setbusinessStreet(street);
      setbusinessBlock(streetBlock);
      setbusinessStreetNumber(streetNumber);
      setbusinessRtNumber(rtNumber);
      setbusinessRwNumber(rwNumber);
    }
  }, [
    selectedIdSubdistrict,
    idRtNumber,
    idRwNumber,
    idStreet,
    idStreetBlock,
    idStreetNumber,
    sameAddress,
    sameResidentialAddress,
    selectedSubdistrict,
    street,
    streetBlock,
    streetNumber,
    rtNumber,
    rwNumber,
  ]);

  const displayStep = (step) => {
    switch (step) {
      case 1:
        return identity();
      case 2:
        return income();
      case 3:
        return address();
      default:
        return null;
    }
  };

  const listSubdistrict = async (search, callback) => {
    setsubdistrictLoading(true);
    try {
      const params = {
        filter: { name: { matchPhrasePrefix: search } },
      };

      const res = await client.graphql({
        query: searchSubdistricts,
        variables: params,
      });

      const items = res.data.searchSubdistricts.items.map((item) => ({
        ...item,
        value: item.id,
        label: item.name,
      }));

      callback(items);
    } catch {
      callback([]);
    } finally {
      setsubdistrictLoading(false);
    }
  };

  const listBusinessType = async (inputValue, callback) => {
    setbusinessCodeLoading(true);
    try {
      const { hits } = await indexRef.current.search(inputValue);
      const options = hits.map((hit) => ({
        value: hit.objectID,
        label: hit.description,
      }));
      callback(options);
    } catch (err) {
      callback([]);
    } finally {
      setbusinessCodeLoading(false);
    }
  };

  const validateFirstForm = () => {
    let valid = true;
    if (nik.length !== 16) valid = false;
    if (kk.length !== 16) valid = false;
    if (!name) valid = false;
    if (!birthPlace) valid = false;
    if (!cellPhone) valid = false;
    if (!birthDate) valid = false;
    return valid;
  };

  const validateSecondForm = () => {
    let valid = true;
    if (!totalDependant) valid = false;
    if (!incomeTaxpayer) valid = false;
    if (!employeeCode && !businessCode && !freelanceCode && !otherCode)
      valid = false;
    return valid;
  };

  const validateThirdForm = () => {
    let valid = true;
    if (!selectedIdSubdistrict) valid = false;
    if (!idStreet) valid = false;
    if (!selectedSubdistrict) valid = false;
    if (!street) valid = false;
    return valid;
  };

  const handleClickCurrentStep = () => {
    const formValidations = {
      1: validateFirstForm(),
      2: validateSecondForm(),
      3: validateThirdForm(),
    };

    const currentFormValid = formValidations[currentStep];
    setformValid({ ...formValid, [currentStep]: currentFormValid });

    return currentFormValid;
  };

  const handleFormNPWP = (isSubmit = false, silent = false) => {
    let modifiedCellPhone = cellPhone;
    if (modifiedCellPhone.startsWith("62")) {
      modifiedCellPhone = "0" + modifiedCellPhone.substring(2);
    }

    const businessBookeeping = useBookeping ? "1" : "2";
    const freelanceBookeeping = freelanceUseBookeping ? "1" : "2";

    const requestData = {
      userID: user.id,
      input: {
        identityId: nik,
        familyId: kk,
        name,
        birthDate: formattedDate,
        birthPlace,
        cellPhone: modifiedCellPhone,
        totalDependant: parseInt(totalDependant),
        incomeLevel: incomeTaxpayer.value,
        employeeCode: employeeSelected ? employeeCode.value : "",
        employeeDescription: employeeSelected ? employeeDescription : "",
        businessCode: businessSelected ? businessCode.value : "",
        businessDescription: businessSelected ? businessDescription : "",
        businessName: businessSelected ? businessName : "",
        businessBookeeping: businessSelected ? businessBookeeping : null,
        businessHasEmployee: businessSelected ? businessHasEmployee : null,
        businessBookeepingStart:
          businessSelected && businessBookeeping === "1"
            ? startBookkeeping
            : "",
        freelanceCode: freelanceSelected ? freelanceCode.value : "",
        freelanceDescription: freelanceSelected ? freelanceDescription : "",
        freelanceName: freelanceSelected ? freelanceName : "",
        freelanceBookeeping: freelanceSelected ? freelanceBookeeping : null,
        freelanceHasEmployee: freelanceSelected ? freelanceHasEmployee : null,
        freelanceBookeepingStart:
          freelanceSelected && freelanceBookeeping === "1"
            ? freelanceBookeepingStart
            : "",
        otherCode: otherSelected ? otherCode.value : "",
        otherDescription: otherSelected ? otherDescription : "",
        idRegionCode: selectedIdSubdistrict?.id || "",
        idStreet,
        idBlock: idStreetBlock,
        idStreetNumber,
        idRtNumber,
        idRwNumber,
        regionCode: selectedSubdistrict?.id || "",
        streetNumber,
        street,
        block: streetBlock,
        rtNumber,
        rwNumber,
        businessRegionCode: businessSelected
          ? selectedBusinessSubdistrict?.id
          : "",
        businessStreet: businessSelected ? businessStreet : "",
        businessBlock: businessSelected ? businessBlock : "",
        businessStreetNumber: businessSelected ? businessStreetNumber : "",
        businessRtNumber: businessSelected ? businessRtNumber : "",
        businessRwNumber: businessSelected ? businessRwNumber : "",
      },
    };
    const requestUpdateData = {
      userID: user.id,
      silent,
      input: {
        id: user.npwpDraftID,
        ...requestData.input,
      },
    };

    if (user.npwpDraftID) {
      isSubmit
        ? requestRegisterNPWP(dispatch, requestUpdateData)
        : requestUpdateNPWPDraft(dispatch, requestUpdateData);
    } else {
      requestCreateNPWPDraft(dispatch, requestData);
    }
  };

  const handleClickPrevious = () => {
    if (currentStep === 1) {
      navigate("/npwp-preregister");
    } else {
      setCurrentStep(currentStep - 1);
    }
  };

  const handleClickNext = () => {
    const currentFormValid = handleClickCurrentStep();
    if (currentFormValid) {
      setCurrentStep(currentStep + 1);
      handleFormNPWP(false, true);
    }
  };

  /* Save Draft */
  const handleSaveDraft = () => {
    handleClickCurrentStep();
    handleFormNPWP(false);
  };

  /* Submit NPWP Register */
  const handleSubmitNPWP = () => {
    const currentFormValid = handleClickCurrentStep();
    if (currentStep === 3) {
      if (currentFormValid) {
        handleFormNPWP(true, true);
      }
    } else {
      handleClickNext();
    }
  };

  const handleFormRegisterNPWP = () => {
    requestGetUser(authDispatch, { sub: user.sub });
    if (user.registeredNpwp?.id) {
      navigate(`/settings/npwp`);
    }
  };

  const formattedDate = dayjs(birthDate).format("DD-MM-YYYY");

  function getErrorMessage(errors) {
    let errorMessage = "";
    if (errors) {
      for (let i = 0; i < errors.length; i++) {
        const error = errors[i];
        if (error.message) {
          if (errorMessage !== "") {
            errorMessage += ` ${error.message}`;
          } else {
            errorMessage += error.message;
          }
        }
      }
    }
    return errorMessage;
  }

  function formSkeleton() {
    return (
      <div className="animate-pulse col-span-12">
        <div className="space-y-6 py-5 lg:px-8 px-3">
          <div className="grid gap-4 sm:grid-cols-2 grid-cols-1">
            <div className="flex-1 space-y-2">
              <div className="w-36 h-4 bg-gray-300 rounded-md"></div>
              <div className="block h-10 bg-gray-300 rounded-md"></div>
            </div>
            <div className="flex-1 space-y-2">
              <div className="w-36 h-4 bg-gray-300 rounded-md"></div>
              <div className="block h-10 bg-gray-300 rounded-md"></div>
            </div>
            <div className="flex-1 space-y-2">
              <div className="w-36 h-4 bg-gray-300 rounded-md"></div>
              <div className="block h-10 bg-gray-300 rounded-md"></div>
            </div>
            <div className="flex-1 space-y-2">
              <div className="w-36 h-4 bg-gray-300 rounded-md"></div>
              <div className="block h-10 bg-gray-300 rounded-md"></div>
            </div>
            <div className="flex-1 space-y-2">
              <div className="w-36 h-4 bg-gray-300 rounded-md"></div>
              <div className="block h-10 bg-gray-300 rounded-md"></div>
            </div>
            <div className="flex-1 space-y-2">
              <div className="w-36 h-4 bg-gray-300 rounded-md"></div>
              <div className="block h-10 bg-gray-300 rounded-md"></div>
            </div>
            <div className="flex-1 space-y-2">
              <div className="w-36 h-4 bg-gray-300 rounded-md"></div>
              <div className="block h-10 bg-gray-300 rounded-md"></div>
            </div>
            <div className="flex-1 space-y-2">
              <div className="w-36 h-4 bg-gray-300 rounded-md"></div>
              <div className="block h-10 bg-gray-300 rounded-md"></div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  /* Button Control */
  function buttonControl() {
    return (
      <div>
        {user.membership === "PREMIUM" ? (
          <div className="py-5 lg:px-8 px-3 flex items-center flex-wrap gap-4 justify-between border-t border-gray-200">
            <div className="flex gap-4">
              <Button
                onClick={() => handleClickPrevious()}
                title="Previous"
                disabled={loading}
                outline
              />
              <Button
                onClick={() => handleSaveDraft()}
                title={"Save Draft"}
                disabled={loading}
                loading={loading}
                outline
              />
            </div>
            <Button
              type="button"
              onClick={() => {
                handleSubmitNPWP();
              }}
              disabled={loading}
              title={`${
                currentStep === 3 ? "Create Now" : `Next (${currentStep}/3)`
              }`}
            />
          </div>
        ) : (
          <div className="py-5 lg:px-8 px-3 flex items-center justify-end border-t border-gray-200">
            <Button
              onClick={() => {
                navigate("/subscription");
              }}
              disabled={getUserLoading}
              type="button"
              title={t("Upgrade to Premium")}
            />
          </div>
        )}
      </div>
    );
  }

  /* Steps control */
  function stepControl() {
    return (
      <div className="flex justify-between items-center mt-5">
        <div className="lg:border-t lg:border-b lg:border-gray-200 flex-1">
          <nav className="lg:px-8 px-3" aria-label="Progress">
            <ol className="rounded-md overflow-hidden lg:flex lg:border-l lg:border-r lg:border-gray-200 lg:rounded-none">
              {steps.map((step, stepIdx) => (
                <li key={step.id} className="relative overflow-hidden flex-1">
                  <div
                    className={classNames(
                      stepIdx === 0 ? "border-b-0 rounded-t-md" : "",
                      stepIdx === steps.length - 1
                        ? "border-t-0 rounded-b-md"
                        : "",
                      "border border-gray-200 overflow-hidden lg:border-0"
                    )}
                  >
                    {formValid[step.id] === false ? (
                      <button onClick={() => setCurrentStep(step.id)}>
                        <span
                          className="absolute top-0 left-0 w-1 h-full bg-red-500 lg:w-full lg:h-1 lg:bottom-0 lg:top-auto"
                          aria-hidden="true"
                        />
                        <span
                          className={classNames(
                            stepIdx !== 0 ? "lg:pl-9" : "",
                            "px-6 py-3 flex items-start text-sm font-medium"
                          )}
                        >
                          <span className="px-6 flex items-center text-sm font-medium">
                            <span className="flex-shrink-0 w-10 h-10 flex items-center justify-center border-2 border-red-500 rounded-full">
                              <span className="flex-shrink-0 w-10 h-10 flex items-center justify-center border-2 bg-red-500 rounded-full">
                                <ExclamationIcon
                                  className="w-6 h-6 text-white"
                                  aria-hidden="true"
                                />
                              </span>
                            </span>
                            <span className="ml-4 text-sm font-medium text-red-500 tracking-wide ">
                              {t(step.name)}
                            </span>
                          </span>
                        </span>
                      </button>
                    ) : formValid[step.id] ? (
                      <button
                        onClick={() =>
                          handleClickCurrentStep() && setCurrentStep(step.id)
                        }
                      >
                        <span
                          className="absolute top-0 left-0 w-1 h-full bg-transparent group-hover:bg-gray-200 lg:w-full lg:h-1 lg:bottom-0 lg:top-auto"
                          aria-hidden="true"
                        />
                        <span
                          className={classNames(
                            stepIdx !== 0 ? "lg:pl-9" : "",
                            "px-6 py-3 flex items-start text-sm font-medium"
                          )}
                        >
                          <span className="px-6 flex items-center text-sm font-medium">
                            <span className="flex-shrink-0 w-10 h-10 flex items-center justify-center border-2 bg-blue-500 rounded-full">
                              <CheckIcon
                                className="w-6 h-6 text-white"
                                aria-hidden="true"
                              />
                            </span>
                            <span className="ml-4 text-sm font-medium text-blue-500 tracking-wide ">
                              {t(step.name)}
                            </span>
                          </span>
                        </span>
                      </button>
                    ) : currentStep === step.id ? (
                      <button onClick={() => setCurrentStep(step.id)}>
                        <span
                          className="absolute top-0 left-0 w-1 h-full bg-blue-500 lg:w-full lg:h-1 lg:bottom-0 lg:top-auto"
                          aria-hidden="true"
                        />
                        <span
                          className={classNames(
                            stepIdx !== 0 ? "lg:pl-9" : "",
                            "px-6 py-3 flex items-start text-sm font-medium"
                          )}
                        >
                          <span className="px-6 flex items-center text-sm font-medium">
                            <span className="flex-shrink-0 w-10 h-10 flex items-center justify-center border-2 border-blue-500 rounded-full">
                              <span className="text-gray-500 group-hover:text-blue-500">
                                {step.id}
                              </span>
                            </span>
                            <span className="ml-4 text-sm font-medium text-blue-500 tracking-wide ">
                              {t(step.name)}
                            </span>
                          </span>
                        </span>
                      </button>
                    ) : (
                      <button
                        onClick={() =>
                          handleClickCurrentStep() && setCurrentStep(step.id)
                        }
                      >
                        <span
                          className="absolute top-0 left-0 w-1 h-full bg-transparent group-hover:bg-gray-200 lg:w-full lg:h-1 lg:bottom-0 lg:top-auto"
                          aria-hidden="true"
                        />
                        <span
                          className={classNames(
                            stepIdx !== 0 ? "lg:pl-9" : "",
                            "px-6 py-3 flex items-start text-sm font-medium"
                          )}
                        >
                          <span className="px-6 flex items-center text-sm font-medium">
                            <span className="flex-shrink-0 w-10 h-10 flex items-center justify-center border-2 border-gray-300 rounded-full group-hover:border-gray-400">
                              <span className="text-gray-500 group-hover:text-gray-900">
                                {step.id}
                              </span>
                            </span>
                            <span className="ml-4 text-sm font-medium tracking-wide text-gray-500 group-hover:text-gray-900">
                              {t(step.name)}
                            </span>
                          </span>
                        </span>
                      </button>
                    )}
                    {stepIdx !== 0 ? (
                      <>
                        {/* Separator */}
                        <div
                          className="hidden absolute top-0 left-0 w-3 inset-0 lg:block"
                          aria-hidden="true"
                        >
                          <svg
                            className="h-full w-full text-gray-300"
                            viewBox="0 0 12 82"
                            fill="none"
                            preserveAspectRatio="none"
                          >
                            <path
                              d="M0.5 0V31L10.5 41L0.5 51V82"
                              stroke="currentcolor"
                              vectorEffect="non-scaling-stroke"
                            />
                          </svg>
                        </div>
                      </>
                    ) : null}
                  </div>
                </li>
              ))}
            </ol>
          </nav>
        </div>
      </div>
    );
  }

  /* indentity forms */
  function identity() {
    return (
      <div>
        {loading ? (
          formSkeleton()
        ) : (
          <div className="space-y-6 py-5 lg:px-8 px-3">
            <div className="grid gap-4 sm:grid-cols-2 grid-cols-1">
              {/* ID Card Number */}
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  {t("ID Card Number")}
                </label>
                <PatternFormat
                  type="text"
                  name="nik"
                  displayType="input"
                  value={nik}
                  onChange={(e) => setnik(e.target.value)}
                  format="################"
                  placeholder={t("Enter ID Card Number")}
                  className="mt-1 block w-full text-sm rounded-md shadow-sm border-gray-300 focus:border-blue-500 focus:ring-blue-500"
                />
              </div>
              {/*  Family Card Number */}
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  {t("Family Card Number")}
                </label>
                <PatternFormat
                  type="text"
                  name="kk"
                  value={kk}
                  onChange={(e) => setkk(e.target.value)}
                  displayType="input"
                  format="################"
                  placeholder={t("Enter Family Card Number")}
                  className="mt-1 block w-full text-sm rounded-md shadow-sm border-gray-300 focus:border-blue-500 focus:ring-blue-500"
                />
              </div>
              {/* Full Name */}
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  {t("Full Name")}
                </label>
                <input
                  type="text"
                  name="name"
                  placeholder={t("Enter Full Name")}
                  value={name}
                  onChange={(e) => setname(e.target.value)}
                  className="mt-1 block w-full text-sm rounded-md shadow-sm border-gray-300 focus:border-blue-500 focus:ring-blue-500"
                />
              </div>
              {/* Place of Birth */}
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  {t("Place of Birth")}
                </label>
                <input
                  type="text"
                  name="birthPlace"
                  value={birthPlace}
                  onChange={(e) => setbirthPlace(e.target.value)}
                  placeholder={t("Enter Place of Birth")}
                  className="mt-1 block w-full text-sm rounded-md shadow-sm border-gray-300 focus:border-blue-500 focus:ring-blue-500"
                />
              </div>
              {/* Date of Birth */}
              <div>
                <label
                  htmlFor="date"
                  className="block text-sm font-medium text-gray-700"
                >
                  {t("Date of Birth")}
                </label>
                <ReactDatePicker
                  className="mt-1 block w-full text-sm rounded-md shadow-sm border-gray-300 focus:border-blue-500 focus:ring-blue-500"
                  name="birthDate"
                  dateFormat="dd-MM-yyyy"
                  selected={birthDate}
                  onChange={setbirthDate}
                  placeholderText={t("Select Date of Birth")}
                />
              </div>
              {/*  Mobile Phone Number */}
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  {t("Mobile Phone Number")}
                </label>
                <PatternFormat
                  id="phone"
                  type="text"
                  name="cellPhone"
                  displayType="input"
                  value={cellPhone}
                  onChange={(e) => setcellPhone(e.target.value)}
                  format="62### #### ####"
                  placeholder={t("Enter Mobile Phone Number")}
                  className="mt-1 block w-full text-sm rounded-md shadow-sm border-gray-300 focus:border-blue-500 focus:ring-blue-500"
                />
              </div>
              {/*  Email */}
              <div>
                <label
                  htmlFor="email"
                  className="block text-sm font-medium text-gray-700"
                >
                  {t("Email")}
                </label>
                <input
                  type="email"
                  name="email"
                  value={user.email || email}
                  onChange={(e) => setemail(e.target.value)}
                  placeholder={t("Enter email")}
                  className="mt-1 block w-full text-sm rounded-md shadow-sm border-gray-300 bg-gray-100 text-gray-500"
                  disabled
                />
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  /* income forms */
  function income() {
    return (
      <div>
        {loading ? (
          formSkeleton()
        ) : (
          <div className="space-y-6 py-5 lg:px-8 px-3">
            <div className="grid gap-4 sm:grid-cols-2 grid-cols-1">
              {/* Total dependents */}
              <div>
                <label
                  htmlFor="totalDependants"
                  className="block text-sm font-medium text-gray-700"
                >
                  {t("Total Dependants")}
                </label>
                <PatternFormat
                  isAllowed={(values) => {
                    const { formattedValue, floatValue } = values;
                    return (
                      formattedValue === "" ||
                      (floatValue <= 9 && floatValue >= 0)
                    );
                  }}
                  type="text"
                  name="totalDependants"
                  value={totalDependant || ""}
                  onChange={(e) => settotalDependant(e.target.value)}
                  displayType="input"
                  format="#"
                  placeholder={t("Enter Number Dependants")}
                  className="mt-1 block w-full text-sm rounded-md shadow-sm border-gray-300 focus:border-blue-500 focus:ring-blue-500"
                />
              </div>
              {/* Taxpayer Income */}
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  {t("Taxpayer Income")}
                </label>
                <ReactSelect
                  className="mt-1 text-sm"
                  classNamePrefix="select2-selection"
                  name="incomeLevel"
                  options={translatedIncomeLevels}
                  value={incomeTaxpayer}
                  onChange={setincomeTaxpayer}
                  placeholder={t("Select Taxpayer Income")}
                />
              </div>
            </div>
            <div className="grid grid-cols-1 gap-6 divide-y">
              <div>
                <label className=" block text-sm font-medium text-gray-700">
                  {t("Source Income")}
                </label>
                <div className="flex flex-col sm:flex-row mt-2 gap-2 ">
                  <div className="flex flex-1 items-center">
                    <input
                      name="sourceIncome"
                      type="checkbox"
                      checked={employeeSelected}
                      onChange={(e) => setemployeeSelected(e.target.checked)}
                      onClick={() => setemployeeSelected(true)}
                      className="focus:ring-blue-500 h-4 w-4 text-blue-500 border-gray-300"
                    />
                    <label className="ml-3 block text-sm font-medium text-gray-700">
                      {t(INCOME_SOURCE[0].label)}
                    </label>
                  </div>
                  <div className="flex flex-1 items-center">
                    <input
                      name="sourceIncome"
                      type="checkbox"
                      checked={businessSelected}
                      onChange={(e) => setbusinessSelected(e.target.checked)}
                      onClick={() => setbusinessSelected(true)}
                      className="focus:ring-blue-500 h-4 w-4 text-blue-500 border-gray-300"
                    />
                    <label className="ml-3 block text-sm font-medium text-gray-700">
                      {t(INCOME_SOURCE[1].label)}
                    </label>
                  </div>
                  <div className="flex flex-1 items-center">
                    <input
                      name="sourceIncome"
                      type="checkbox"
                      checked={freelanceSelected}
                      onChange={(e) => setfreelanceSelected(e.target.checked)}
                      className="focus:ring-blue-500 h-4 w-4 text-blue-500 border-gray-300"
                    />
                    <label className="ml-3 block text-sm font-medium text-gray-700">
                      {t(INCOME_SOURCE[2].label)}
                    </label>
                  </div>
                  <div className="flex flex-1 items-center">
                    <input
                      name="sourceIncome"
                      type="checkbox"
                      checked={otherSelected}
                      onChange={(e) => setotherSelected(e.target.checked)}
                      className="focus:ring-blue-500 h-4 w-4 text-blue-500 border-gray-300"
                    />
                    <label className="ml-3 block text-sm font-medium text-gray-700">
                      {t(INCOME_SOURCE[3].label)}
                    </label>
                  </div>
                </div>
              </div>

              {/* Information Employment as an Employee */}
              {employeeSelected && (
                <div>
                  <h3 className="pb-2 text-lg font-bold text-gray-700">
                    {t("Informasi Pekerjaan Sebagai Karyawan")}
                  </h3>
                  <div className="grid gap-4 sm:grid-cols-2 grid-cols-1">
                    {/* Type Employee */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700">
                        {t("Type Employee")}
                      </label>
                      <ReactSelect
                        className="mt-1 text-sm"
                        classNamePrefix="select2-selection"
                        name="typeEmployee"
                        options={translatedEmployeeTypes}
                        value={employeeCode}
                        onChange={setemployeeCode}
                        placeholder={t("Select Taxpayer Income")}
                      />
                    </div>
                    {/* Information */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700">
                        {t("Information")}
                      </label>
                      <input
                        name="employeeDescription"
                        type="text"
                        value={employeeDescription}
                        onChange={(e) => setemployeeDescription(e.target.value)}
                        placeholder={t("Enter Information")}
                        className="mt-1 w-full text-sm rounded-md shadow-sm border-gray-300 focus:border-blue-500 focus:ring-blue-500"
                      />
                    </div>
                  </div>
                </div>
              )}

              {/* Business Information */}
              {businessSelected && (
                <div>
                  <h3 className="pb-2 text-lg font-bold text-gray-700">
                    {t("Business Employee Information")}
                  </h3>
                  <div className="grid gap-4 sm:grid-cols-2 grid-cols-1">
                    {/* Business Type */}
                    <div>
                      <label
                        htmlFor="businessType"
                        className="block text-sm font-medium text-gray-700"
                      >
                        {t("Business Type")}
                      </label>
                      <AsyncSelect
                        name="businessType"
                        value={businessCode}
                        isClearable
                        defaultOptions
                        isLoading={businessCodeLoading}
                        onChange={setbusinessCode}
                        loadOptions={listBusinessType}
                        className="mt-1 text-sm"
                        classNamePrefix="select2-selection"
                        placeholder={t("Select Business Type")}
                      />
                    </div>
                    {/*  Business Information */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700">
                        {t("Business Information")}
                      </label>
                      <input
                        name="businessDescription"
                        type="text"
                        value={businessDescription}
                        onChange={(e) => setbusinessDescription(e.target.value)}
                        placeholder={t("Enter Business Information")}
                        className="mt-1 w-full text-sm rounded-md shadow-sm border-gray-300 focus:border-blue-500 focus:ring-blue-500"
                      />
                    </div>
                    {/*  Business Name */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700">
                        {t("Business Name")}
                      </label>
                      <input
                        name="businessName"
                        type="text"
                        value={businessName}
                        onChange={(e) => setbusinessName(e.target.value)}
                        placeholder={t("Enter Business Name")}
                        className="mt-1 w-full text-sm rounded-md shadow-sm border-gray-300 focus:border-blue-500 focus:ring-blue-500"
                      />
                    </div>
                    {/*  business employee description */}
                    <div>
                      <label className=" block text-sm font-medium text-gray-700">
                        {t("Has Employee?")}
                      </label>
                      <div className="flex flex-col sm:flex-row mt-2 gap-2 ">
                        <div className="flex flex-1 items-center mt-1 ">
                          <input
                            id="yes"
                            name="businessHasEmployee"
                            type="radio"
                            value={true}
                            defaultChecked={businessHasEmployee === true}
                            onChange={(e) =>
                              setbusinessHasEmployee(e.target.value)
                            }
                            className="focus:ring-blue-500 h-4 w-4 text-blue-500 border-gray-300"
                          />
                          <label
                            htmlFor="yes"
                            className="ml-3 block text-sm font-medium text-gray-700"
                          >
                            {t("Yes")}
                          </label>
                        </div>
                        <div className="flex flex-1 items-center mt-1 ">
                          <input
                            id="no"
                            name="businessHasEmployee"
                            type="radio"
                            value={false}
                            defaultChecked={businessHasEmployee === false}
                            onChange={(e) =>
                              setbusinessHasEmployee(e.target.value)
                            }
                            className="focus:ring-blue-500 h-4 w-4 text-blue-500 border-gray-300"
                          />
                          <label
                            htmlFor="no"
                            className="ml-3 block text-sm font-medium text-gray-700"
                          >
                            {t("No")}
                          </label>
                        </div>
                      </div>
                    </div>
                    {/* Bookkeeping Type */}
                    <div>
                      <label className=" block text-sm font-medium text-gray-700">
                        {t("Bookkeeping Type")}
                      </label>
                      <div className="flex flex-col sm:flex-row mt-2 gap-2 ">
                        {BOOKKEEPING_TYPES.map((item) => (
                          <div
                            key={item.value}
                            className="flex flex-1 items-center mt-1"
                          >
                            <input
                              name="businessBookkeeping"
                              type="radio"
                              value={item.value.toString()}
                              defaultChecked={useBookeping === item.value}
                              onChange={(e) =>
                                setuseBookeping(e.target.value === "true")
                              }
                              className="focus:ring-blue-500 h-4 w-4 text-blue-500 border-gray-300"
                            />
                            <label className="ml-3 block text-sm font-medium text-gray-700">
                              {t(item.label)}
                            </label>
                          </div>
                        ))}
                      </div>
                    </div>
                    {/* Select Bookkeeping Start */}
                    {useBookeping === true && (
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          {t("Select Bookkeeping Start")}
                        </label>
                        <select
                          className="mt-1 block w-full text-sm rounded-md border border-gray-300 bg-white py-2 px-3 shadow-sm focus:border-blue-500 focus:outline-none focus:ring-blue-500"
                          name="startBookkeeping"
                          value={startBookkeeping}
                          onChange={(e) => setstartBookkeeping(e.target.value)}
                        >
                          {MONTHS.map((item) => (
                            <option key={item.value} value={item.value}>
                              {t(item.label)}
                            </option>
                          ))}
                        </select>
                      </div>
                    )}
                  </div>
                </div>
              )}

              {/* Freelance Information  */}
              {freelanceSelected && (
                <div>
                  <h3 className="pb-2 text-lg font-bold text-gray-700">
                    {t("Freelance Information")}
                  </h3>
                  <div className="grid gap-4 sm:grid-cols-2 grid-cols-1">
                    {/* Freelance Type */}
                    <div>
                      <label
                        htmlFor="freelanceType"
                        className="block text-sm font-medium text-gray-700"
                      >
                        {t("Freelance Type")}
                      </label>
                      <AsyncSelect
                        name="freelanceType"
                        value={freelanceCode || ""}
                        isClearable
                        defaultOptions
                        isLoading={businessCodeLoading}
                        loadOptions={listBusinessType}
                        onChange={setfreelanceCode}
                        className="mt-1 text-sm"
                        classNamePrefix="select2-selection"
                        placeholder={t("Select Freelance Type")}
                      />
                    </div>
                    {/*  Freelance Description */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700">
                        {t("Freelance Description")}
                      </label>
                      <input
                        name="freelanceDescription"
                        type="text"
                        value={freelanceDescription}
                        onChange={(e) =>
                          setfreelanceDescription(e.target.value)
                        }
                        placeholder={t("Enter Freelance Description")}
                        className="mt-1 w-full text-sm rounded-md shadow-sm border-gray-300 focus:border-blue-500 focus:ring-blue-500"
                      />
                    </div>
                    {/*  Freelance Name */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700">
                        {t("Business Name")}
                      </label>
                      <input
                        name="businessName"
                        type="text"
                        value={freelanceName}
                        onChange={(e) => setfreelanceName(e.target.value)}
                        placeholder={t("Enter Business Name")}
                        className="mt-1 w-full text-sm rounded-md shadow-sm border-gray-300 focus:border-blue-500 focus:ring-blue-500"
                      />
                    </div>
                    {/*  Freelance Employee Description */}
                    <div>
                      <label className=" block text-sm font-medium text-gray-700">
                        {t("Has Employee?")}
                      </label>
                      <div className="flex flex-col sm:flex-row mt-2 gap-2 ">
                        <div className="flex flex-1 items-center mt-1 ">
                          <input
                            id="yes"
                            name="freelanceHasEmployee"
                            type="radio"
                            value={true}
                            defaultChecked={freelanceHasEmployee === true}
                            onChange={(e) =>
                              setfreelanceHasEmployee(e.target.value)
                            }
                            className="focus:ring-blue-500 h-4 w-4 text-blue-500 border-gray-300"
                          />
                          <label
                            htmlFor="yes"
                            className="ml-3 block text-sm font-medium text-gray-700"
                          >
                            {t("Yes")}
                          </label>
                        </div>
                        <div className="flex flex-1 items-center mt-1 ">
                          <input
                            id="no"
                            name="freelanceHasEmployee"
                            type="radio"
                            value={false}
                            defaultChecked={freelanceHasEmployee === false}
                            onChange={(e) =>
                              setfreelanceHasEmployee(e.target.value)
                            }
                            className="focus:ring-blue-500 h-4 w-4 text-blue-500 border-gray-300"
                          />
                          <label
                            htmlFor="no"
                            className="ml-3 block text-sm font-medium text-gray-700"
                          >
                            {t("No")}
                          </label>
                        </div>
                      </div>
                    </div>
                    {/* Bookkeeping Type */}
                    <div>
                      <label className=" block text-sm font-medium text-gray-700">
                        {t("Bookkeeping Type")}
                      </label>
                      <div className="flex flex-col sm:flex-row mt-2 gap-2 ">
                        {BOOKKEEPING_TYPES.map((item) => (
                          <div
                            key={item.value}
                            className="flex flex-1 items-center mt-1"
                          >
                            <input
                              name="bookkeepingType"
                              type="radio"
                              value={item.value.toString()}
                              defaultChecked={
                                freelanceUseBookeping === item.value
                              }
                              onChange={(e) =>
                                setfreelanceUseBookeping(
                                  e.target.value === "true"
                                )
                              }
                              className="focus:ring-blue-500 h-4 w-4 text-blue-500 border-gray-300"
                            />
                            <label className="ml-3 block text-sm font-medium text-gray-700">
                              {t(item.label)}
                            </label>
                          </div>
                        ))}
                      </div>
                    </div>
                    {freelanceUseBookeping === true && (
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          {t("Select Bookkeeping Start")}
                        </label>
                        <select
                          className="mt-1 block w-full text-sm rounded-md border border-gray-300 bg-white py-2 px-3 shadow-sm focus:border-blue-500 focus:outline-none focus:ring-blue-500"
                          name="freelanceBookeepingStart"
                          value={freelanceBookeepingStart}
                          onChange={(e) =>
                            setfreelanceBookeepingStart(e.target.value)
                          }
                        >
                          {MONTHS.map((item) => (
                            <option key={item.value} value={item.value}>
                              {t(item.label)}
                            </option>
                          ))}
                        </select>
                      </div>
                    )}
                  </div>
                </div>
              )}

              {/* Other Information  */}
              {otherSelected && (
                <div>
                  <h3 className="pb-2 text-lg font-bold text-gray-700">
                    {t("Other Work Information")}
                  </h3>
                  <div className="grid gap-4 sm:grid-cols-2 grid-cols-1">
                    {/* Other Income Type */}
                    <div>
                      <label
                        htmlFor="otherIncomeType"
                        className="block text-sm font-medium text-gray-700"
                      >
                        {t("Other Income Type")}
                      </label>
                      <AsyncSelect
                        name="otherType"
                        value={otherCode || ""}
                        isLoading={businessCodeLoading}
                        loadOptions={listBusinessType}
                        onChange={setotherCode}
                        isClearable
                        defaultOptions
                        className="mt-1 text-sm"
                        classNamePrefix="select2-selection"
                        placeholder={t("Select Other Income Type")}
                      />
                    </div>
                    {/*  Other Description */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700">
                        {t("Other Description")}
                      </label>
                      <input
                        name="otherDescription"
                        type="text"
                        value={otherDescription}
                        onChange={(e) => setotherDescription(e.target.value)}
                        placeholder={t("Enter Other Description")}
                        className="mt-1 w-full text-sm rounded-md shadow-sm border-gray-300 focus:border-blue-500 focus:ring-blue-500"
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }

  /* address forms */
  function address() {
    return (
      <div>
        {loading ? (
          formSkeleton()
        ) : (
          <div className="space-y-6 py-5 lg:px-8 px-3">
            <h3 className="text-lg font-bold text-gray-700">
              {t("Identity Address")}
            </h3>
            {/* Address Identity */}
            <div className="grid gap-4 sm:grid-cols-2 grid-cols-1">
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  {t("Identity Village")}
                </label>
                <AsyncSelect
                  className="mt-1 text-sm"
                  classNamePrefix="select2-selection"
                  name="idVillage"
                  isClearable
                  isLoading={subdistrictLoading}
                  defaultOptions
                  loadOptions={listSubdistrict}
                  value={selectedIdSubdistrict}
                  onChange={setselectedIdSubdistrict}
                  placeholder={t("Select Identity Village")}
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  {t("Identity Subdistrict")}
                </label>
                <input
                  name="idSubdistrict"
                  type="text"
                  value={selectedIdSubdistrict?.district?.name || ""}
                  placeholder={t("Identity Village Not Selected")}
                  className="mt-1 block w-full text-sm rounded-md shadow-sm border-gray-300 bg-gray-100 text-gray-500"
                  disabled
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  {t("Identity Regency")}
                </label>
                <input
                  name="idRegency"
                  type="text"
                  value={selectedIdSubdistrict?.district?.city?.name || ""}
                  placeholder={t("Identity Village Not Selected")}
                  className="mt-1 block w-full text-sm rounded-md shadow-sm border-gray-300 bg-gray-100 text-gray-500"
                  disabled
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  {t("Identity Province")}
                </label>
                <input
                  name="idProvince"
                  type="text"
                  value={
                    selectedIdSubdistrict?.district?.city?.province?.name || ""
                  }
                  placeholder={t("Identity Village Not Selected")}
                  className="mt-1 block w-full text-sm rounded-md shadow-sm border-gray-300 bg-gray-100 text-gray-500"
                  disabled
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  {t("Identity Street Address")}
                </label>
                <div className="mt-1">
                  <input
                    name="idStreet"
                    type="text"
                    value={idStreet}
                    onChange={(e) => setidStreet(e.target.value)}
                    placeholder={t("Enter Identity Street Address")}
                    className="mt-1 w-full text-sm rounded-md shadow-sm border-gray-300 focus:border-blue-500 focus:ring-blue-500"
                  />
                </div>
              </div>
              <div className="flex gap-4 justify-between">
                <div className="flex-1">
                  <div className=" flex flex-nowrap">
                    <label className="block text-sm font-medium text-gray-700">
                      {t("RT")}
                    </label>
                    <span className="block text-sm font-normal text-gray-500">
                      &nbsp; &#40;
                      {t("Optional")}
                      &#41;
                    </span>
                  </div>
                  <input
                    name="idRtNumber"
                    type="text"
                    value={idRtNumber}
                    onChange={(e) => setidRtNumber(e.target.value)}
                    placeholder={t("Enter RT")}
                    className="mt-1 w-full text-sm rounded-md shadow-sm border-gray-300 focus:border-blue-500 focus:ring-blue-500"
                  />
                </div>
                <div className="flex-1">
                  <div className=" flex flex-nowrap">
                    <label className="block text-sm font-medium text-gray-700">
                      {t("RW")}
                    </label>
                    <span className="block text-sm font-normal text-gray-500">
                      &nbsp; &#40;
                      {t("Optional")}
                      &#41;
                    </span>
                  </div>
                  <input
                    name="idRwNumber"
                    type="text"
                    value={idRwNumber}
                    onChange={(e) => setidRwNumber(e.target.value)}
                    placeholder={t("Enter RW")}
                    className="mt-1 w-full text-sm rounded-md shadow-sm border-gray-300 focus:border-blue-500 focus:ring-blue-500"
                  />
                </div>
              </div>
              <div className="flex gap-4 justify-between">
                <div className="flex-1">
                  <div className=" flex flex-nowrap">
                    <label className="block text-sm font-medium text-gray-700">
                      {t("Street Number")}
                    </label>
                    <span className="block text-sm font-normal text-gray-500">
                      &nbsp; &#40;
                      {t("Optional")}
                      &#41;
                    </span>
                  </div>
                  <input
                    name="idstreetNumber"
                    type="text"
                    value={idStreetNumber}
                    onChange={(e) => setidStreetNumber(e.target.value)}
                    placeholder={t("Enter Street Number")}
                    className="mt-1 w-full text-sm rounded-md shadow-sm border-gray-300 focus:border-blue-500 focus:ring-blue-500"
                  />
                </div>
                <div className="flex-1">
                  <div className=" flex flex-nowrap">
                    <label className="block text-sm font-medium text-gray-700">
                      {t("Address Block")}
                    </label>
                    <span className="block text-sm font-normal text-gray-500">
                      &nbsp; &#40;
                      {t("Optional")}
                      &#41;
                    </span>
                  </div>
                  <input
                    name="idaddressBlock"
                    type="text"
                    value={idStreetBlock}
                    onChange={(e) => setidStreetBlock(e.target.value)}
                    placeholder={t("Enter Address Block")}
                    className="mt-1 w-full text-sm rounded-md shadow-sm border-gray-300 focus:border-blue-500 focus:ring-blue-500"
                  />
                </div>
              </div>
            </div>

            {/* Residential Address*/}
            <div>
              <h3 className="pb-1 text-lg font-bold text-gray-700">
                {t("Residential Address")}
              </h3>
              <div className="flex items-center">
                <input
                  type="checkbox"
                  checked={sameAddress}
                  onChange={(e) => setsameAddress(e.target.checked)}
                  onClick={() => setsameAddress(true)}
                  className="focus:ring-blue-500 h-4 w-4 text-blue-500 border-gray-300"
                />
                <label className="ml-3 block text-sm font-medium text-gray-700">
                  {t("Same as Identity Address")}
                </label>
              </div>
            </div>
            {sameAddress === false && (
              <div className="grid gap-4 sm:grid-cols-2 grid-cols-1">
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    {t("Village")}
                  </label>
                  <AsyncSelect
                    className="mt-1 text-sm"
                    classNamePrefix="select2-selection"
                    name="village"
                    isClearable
                    isLoading={subdistrictLoading}
                    defaultOptions
                    loadOptions={listSubdistrict}
                    value={selectedSubdistrict}
                    onChange={setselectedSubdistrict}
                    placeholder={t("Select Village")}
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    {t("Subdistrict")}
                  </label>
                  <input
                    name="subdistrict"
                    type="text"
                    value={selectedSubdistrict?.district?.name || ""}
                    placeholder={t("Village Not Selected")}
                    className="mt-1 block w-full text-sm rounded-md shadow-sm border-gray-300 bg-gray-100 text-gray-500"
                    disabled
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    {t("Regency")}
                  </label>
                  <input
                    name="regency"
                    type="text"
                    value={selectedSubdistrict?.district?.city?.name || ""}
                    placeholder={t("Village Not Selected")}
                    className="mt-1 block w-full text-sm rounded-md shadow-sm border-gray-300 bg-gray-100 text-gray-500"
                    disabled
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    {t("Province")}
                  </label>
                  <input
                    name="province"
                    type="text"
                    value={
                      selectedSubdistrict?.district?.city?.province?.name || ""
                    }
                    placeholder={t("Village Not Selected")}
                    className="mt-1 block w-full text-sm rounded-md shadow-sm border-gray-300 bg-gray-100 text-gray-500"
                    disabled
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    {t("Street Address")}
                  </label>
                  <div className="mt-1">
                    <input
                      name="streetAddress"
                      type="text"
                      value={street}
                      onChange={(e) => setstreet(e.target.value)}
                      placeholder={t("Enter Street Address")}
                      className="mt-1 w-full text-sm rounded-md shadow-sm border-gray-300 focus:border-blue-500 focus:ring-blue-500"
                    />
                  </div>
                </div>
                <div className="flex gap-4 justify-between">
                  <div className="flex-1">
                    <div className=" flex flex-nowrap">
                      <label className="block text-sm font-medium text-gray-700">
                        {t("RT")}
                      </label>
                      <span className="block text-sm font-normal text-gray-500">
                        &nbsp; &#40;
                        {t("Optional")}
                        &#41;
                      </span>
                    </div>
                    <input
                      name="rtNumber"
                      type="text"
                      value={rtNumber}
                      onChange={(e) => setrtNumber(e.target.value)}
                      placeholder={t("Enter RT")}
                      className="mt-1 w-full text-sm rounded-md shadow-sm border-gray-300 focus:border-blue-500 focus:ring-blue-500"
                    />
                  </div>
                  <div className="flex-1">
                    <div className=" flex flex-nowrap">
                      <label className="block text-sm font-medium text-gray-700">
                        {t("RW")}
                      </label>
                      <span className="block text-sm font-normal text-gray-500">
                        &nbsp; &#40;
                        {t("Optional")}
                        &#41;
                      </span>
                    </div>
                    <input
                      name="rwNumber"
                      type="text"
                      value={rwNumber}
                      onChange={(e) => setrwNumber(e.target.value)}
                      placeholder={t("Enter RW")}
                      className="mt-1 w-full text-sm rounded-md shadow-sm border-gray-300 focus:border-blue-500 focus:ring-blue-500"
                    />
                  </div>
                </div>
                <div className="flex gap-4 justify-between">
                  <div className="flex-1">
                    <div className=" flex flex-nowrap">
                      <label className="block text-sm font-medium text-gray-700">
                        {t("Street Number")}
                      </label>
                      <span className="block text-sm font-normal text-gray-500">
                        &nbsp; &#40;
                        {t("Optional")}
                        &#41;
                      </span>
                    </div>
                    <input
                      name="StreetNumber"
                      type="text"
                      value={streetNumber}
                      onChange={(e) => setstreetNumber(e.target.value)}
                      placeholder={t("Enter Street Number")}
                      className="mt-1 w-full text-sm rounded-md shadow-sm border-gray-300 focus:border-blue-500 focus:ring-blue-500"
                    />
                  </div>
                  <div className="flex-1">
                    <div className=" flex flex-nowrap">
                      <label className="block text-sm font-medium text-gray-700">
                        {t("Address Block")}
                      </label>
                      <span className="block text-sm font-normal text-gray-500">
                        &nbsp; &#40;
                        {t("Optional")}
                        &#41;
                      </span>
                    </div>
                    <input
                      name="addressBlock"
                      type="text"
                      value={streetBlock}
                      onChange={(e) => setstreetBlock(e.target.value)}
                      placeholder={t("Enter Address Block")}
                      className="mt-1 w-full text-sm rounded-md shadow-sm border-gray-300 focus:border-blue-500 focus:ring-blue-500"
                    />
                  </div>
                </div>
              </div>
            )}

            {/* Business Adddress */}
            {businessSelected && (
              <div>
                <div>
                  <h3 className="pb-1 text-lg font-bold text-gray-700">
                    {t("Business Address")}
                  </h3>
                  <div className="pb-6 flex items-center">
                    <input
                      type="checkbox"
                      checked={sameResidentialAddress}
                      onChange={(e) =>
                        setsameResidentialAddress(e.target.checked)
                      }
                      onClick={() => setsameResidentialAddress(true)}
                      className="focus:ring-blue-500 h-4 w-4 text-blue-500 border-gray-300"
                    />
                    <label className="pb-1 ml-3 block text-sm font-medium text-gray-700">
                      {t("Same as Residential Address")}
                    </label>
                  </div>
                </div>
                {sameResidentialAddress === false && (
                  <div className="grid gap-4 sm:grid-cols-2 grid-cols-1">
                    <div>
                      <label className="block text-sm font-medium text-gray-700">
                        {t("Village")}
                      </label>
                      <AsyncSelect
                        className="mt-1 text-sm"
                        classNamePrefix="select2-selection"
                        name="businessVillage"
                        isClearable
                        isLoading={subdistrictLoading}
                        defaultOptions
                        loadOptions={listSubdistrict}
                        value={selectedBusinessSubdistrict}
                        onChange={setselectedBusinessSubdistrict}
                        placeholder={t("Select Village")}
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700">
                        {t("Subdistrict")}
                      </label>
                      <input
                        name="businessSubdistrict"
                        type="text"
                        value={
                          selectedBusinessSubdistrict?.district?.name || ""
                        }
                        placeholder={t("Village Not Selected")}
                        className="mt-1 block w-full text-sm rounded-md shadow-sm border-gray-300 bg-gray-100 text-gray-500"
                        disabled
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700">
                        {t("Regency")}
                      </label>
                      <input
                        name="businessRegency"
                        type="text"
                        value={
                          selectedBusinessSubdistrict?.district?.city?.name ||
                          ""
                        }
                        placeholder={t("Village Not Selected")}
                        className="mt-1 block w-full text-sm rounded-md shadow-sm border-gray-300 bg-gray-100 text-gray-500"
                        disabled
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700">
                        {t("Province")}
                      </label>
                      <input
                        name="businessProvince"
                        type="text"
                        value={
                          selectedBusinessSubdistrict?.district?.city?.province
                            ?.name || ""
                        }
                        placeholder={t("Village Not Selected")}
                        className="mt-1 block w-full text-sm rounded-md shadow-sm border-gray-300 bg-gray-100 text-gray-500"
                        disabled
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700">
                        {t("Street Address")}
                      </label>
                      <div className="mt-1">
                        <input
                          name="businessStreet"
                          type="text"
                          value={businessStreet}
                          onChange={(e) => setbusinessStreet(e.target.value)}
                          placeholder={t("Enter Street Address")}
                          className="mt-1 w-full text-sm rounded-md shadow-sm border-gray-300 focus:border-blue-500 focus:ring-blue-500"
                        />
                      </div>
                    </div>
                    <div className="flex gap-4 justify-between">
                      <div className="flex-1">
                        <div className=" flex flex-nowrap">
                          <label className="block text-sm font-medium text-gray-700">
                            {t("RT")}
                          </label>
                          <span className="block text-sm font-normal text-gray-500">
                            &nbsp; &#40;
                            {t("Optional")}
                            &#41;
                          </span>
                        </div>
                        <input
                          name="businessRtNumber"
                          type="text"
                          value={businessRtNumber}
                          onChange={(e) => setbusinessRtNumber(e.target.value)}
                          placeholder={t("Enter RT")}
                          className="mt-1 w-full text-sm rounded-md shadow-sm border-gray-300 focus:border-blue-500 focus:ring-blue-500"
                        />
                      </div>
                      <div className="flex-1">
                        <div className=" flex flex-nowrap">
                          <label className="block text-sm font-medium text-gray-700">
                            {t("RW")}
                          </label>
                          <span className="block text-sm font-normal text-gray-500">
                            &nbsp; &#40;
                            {t("Optional")}
                            &#41;
                          </span>
                        </div>
                        <input
                          name="businessRwNumber"
                          type="text"
                          value={businessRwNumber}
                          onChange={(e) => setbusinessRwNumber(e.target.value)}
                          placeholder={t("Enter RW")}
                          className="mt-1 w-full text-sm rounded-md shadow-sm border-gray-300 focus:border-blue-500 focus:ring-blue-500"
                        />
                      </div>
                    </div>
                    <div className="flex gap-4 justify-between">
                      <div className="flex-1">
                        <div className=" flex flex-nowrap">
                          <label className="block text-sm font-medium text-gray-700">
                            {t("Street Number")}
                          </label>
                          <span className="block text-sm font-normal text-gray-500">
                            &nbsp; &#40;
                            {t("Optional")}
                            &#41;
                          </span>
                        </div>
                        <input
                          name="businessStreetNumber"
                          type="text"
                          value={businessStreetNumber}
                          onChange={(e) =>
                            setbusinessStreetNumber(e.target.value)
                          }
                          placeholder={t("Enter Street Number")}
                          className="mt-1 w-full text-sm rounded-md shadow-sm border-gray-300 focus:border-blue-500 focus:ring-blue-500"
                        />
                      </div>
                      <div className="flex-1">
                        <div className=" flex flex-nowrap">
                          <label className="block text-sm font-medium text-gray-700">
                            {t("Address Block")}
                          </label>
                          <span className="block text-sm font-normal text-gray-500">
                            &nbsp; &#40;
                            {t("Optional")}
                            &#41;
                          </span>
                        </div>
                        <input
                          name="businessBlock"
                          type="text"
                          value={businessBlock}
                          onChange={(e) => setbusinessBlock(e.target.value)}
                          placeholder={t("Enter Address Block")}
                          className="mt-1 w-full text-sm rounded-md shadow-sm border-gray-300 focus:border-blue-500 focus:ring-blue-500"
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        )}
      </div>
    );
  }

  return (
    <div className=" bg-white border border-gray-200 divide-y divide-gray-200 shadow rounded-md sm:rounded-lg ">
      <ModalConfirm
        open={showDraftSuccessModal}
        setOpen={(open) => {
          setshowDraftSuccessModal(open);
        }}
        title="Success"
        description="NPWP draft has been successfully saved"
        type="SUCCESS"
        onConfirm={() => {
          clearUpdateNPWPDraft(dispatch);
        }}
      />

      <ModalConfirm
        open={showSubmitSuccessModal}
        setOpen={(open) => {
          setshowSubmitSuccessModal(open);
        }}
        title="Success"
        description="The NPWP creation has been successful"
        type="SUCCESS"
        onConfirm={() => {
          handleFormRegisterNPWP();
          clearRegisterNPWP(dispatch);
        }}
      />

      <ModalConfirm
        open={showDraftErrorModal && modalDraftDescription !== ""}
        setOpen={(open) => setshowDraftErrorModal(open)}
        title="Error"
        description={modalDraftDescription}
        type="ALERT"
        onConfirm={() => setshowDraftErrorModal(false)}
      />

      <ModalConfirm
        open={showSubmitErrorModal && modalSubmitDescription !== ""}
        setOpen={(open) => setshowSubmitErrorModal(open)}
        title="Error"
        description={modalSubmitDescription}
        type="ALERT"
        onConfirm={() => {
          setshowSubmitErrorModal(false);
          clearRegisterNPWP(dispatch);
        }}
      />
      {npwp_registration === "enabled" ? (
        <div>
          <div>{stepControl()}</div>
          {formValid[currentStep] === false && (
            <div className="pt-6 sm:px-3 lg:px-8">
              <Alert
                title="Incomplete Form"
                type="warning"
                message="Please fill out all fields."
              />
            </div>
          )}

          <div>{displayStep(currentStep)}</div>

          <div>{buttonControl()}</div>
        </div>
      ) : (
        <div className="px-4 py-6 sm:px-6">
          <Alert
            title="Sorry"
            type="warning"
            message="The service is currently unavailable."
          />
        </div>
      )}
    </div>
  );
};

const searchSubdistricts = /* GraphQL */ `
  query SearchSubdistricts(
    $filter: SearchableSubdistrictFilterInput
    $sort: SearchableSubdistrictSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchSubdistricts(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        name
        district {
          id
          name
          city {
            id
            name
            province {
              id
              name
            }
          }
          createdAt
          updatedAt
        }
      }
      nextToken
      total
    }
  }
`;

const getSubdistrict = /* GraphQL */ `
  query GetSubdistrict($id: ID!) {
    getSubdistrict(id: $id) {
      id
      name
      district {
        id
        name
        city {
          id
          name
          province {
            id
            name
          }
        }
      }
    }
  }
`;

const getBusinessCode = /* GraphQL */ `
  query GetBusinessCode($id: ID!) {
    getBusinessCode(id: $id) {
      id
      description
    }
  }
`;
